import { takeLatest } from 'redux-saga/effects'
import { FETCH_SUPPORT_LIST_SAGA } from 'src/store/types/adminData'
import fetchSupportList from './fetchSupportList'

export function* supportListSaga() {
  yield takeLatest(FETCH_SUPPORT_LIST_SAGA, fetchSupportList)
}
